module.exports = __webpack_public_path__ + "static/media/main-logo.22b70f9b.png";